import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { contextConnect, useContextSystem } from '@wp-g2/context';
import { cx } from '@wp-g2/styles';
import React from 'react';
import { Tab as ReakitTab } from 'reakit';
import { useTabsContext } from './Tabs.Context';
import * as styles from './Tabs.styles';
var TabView = styles.TabView;

function Tab(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'Tab'),
      className = _useContextSystem.className,
      size = _useContextSystem.size,
      otherProps = _objectWithoutProperties(_useContextSystem, ["className", "size"]);

  var _useTabsContext = useTabsContext(),
      tab = _useTabsContext.tab;

  var classes = cx(styles[size], className);
  return /*#__PURE__*/React.createElement(ReakitTab, Object.assign({
    as: TabView,
    className: classes,
    ref: forwardedRef
  }, tab, otherProps));
}

export default contextConnect(Tab, 'Tab');